import { render, staticRenderFns } from "./table-data-source.vue?vue&type=template&id=a2c4ca2e&"
import script from "./table-data-source.vue?vue&type=script&lang=js&"
export * from "./table-data-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports